import "./src/styles/global.css";
import "katex/dist/katex.css";

// A reload, a back or forward navigation (popstate, or a full page load from the
// browser history) restores the saved scroll position; every other navigation starts
// at the top, including full page loads from plain links such as the navbar's. Gatsby
// records the current position under the new page's history entry while navigating,
// so restoring it on a link click would open the new page part-way down.
// The history entry a back or forward navigation went to, keyed as @reach/router keys
// locations; matching the key means a popstate whose page never reaches the hook (for
// example one that scrolls to a hash) cannot affect a later link navigation.
let poppedKey = null;
if (typeof window !== "undefined") {
  window.addEventListener("popstate", (event) => {
    poppedKey = event.state?.key || "initial";
  });
}

// Whether this page load was a reload or a back/forward traversal, rather than a
// visit from a link or the address bar
const loadedFromHistory = () => {
  const [entry] = performance.getEntriesByType("navigation");
  return entry?.type === "reload" || entry?.type === "back_forward";
};

// https://github.com/gatsbyjs/gatsby/issues/38201#issuecomment-1631378720
export const shouldUpdateScroll = ({
  routerProps: { location },
  prevRouterProps,
  getSavedScrollPosition,
}) => {
  const fromHistory = poppedKey !== null && location.key === poppedKey;
  poppedKey = null;

  if (location.hash) {
    return true;
  }

  // In-page updates such as the News filters keep the visitor's position. The flag
  // stays on the history entry, so only honour it for a new navigation within the
  // same page; back and forward restore the saved position as usual.
  if (
    location.state?.keepScroll &&
    !fromHistory &&
    prevRouterProps?.location.pathname === location.pathname
  ) {
    return false;
  }

  const restore = fromHistory || (!prevRouterProps && loadedFromHistory());
  const [left, top] = (restore && getSavedScrollPosition(location)) || [0, 0];

  // Instant, so the page's smooth scrolling does not animate the jump
  setTimeout(() => {
    window.scrollTo({ left, top, behavior: "instant" });
  }, 0);

  return false;
};
